<template>
  <div>
    <a-descriptions bordered :size="'small'">
      <a-descriptions-item v-if="emoInfo.ips_desc" label="IPS">
        {{emoInfo.ips_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.tipo_emo" label="Tipo E.M.O">
        {{emoInfo.tipo_emo}}
      </a-descriptions-item>
      <a-descriptions-item label="P.V.E “Plan de Vigilancia Epidemiológica”">
        Cardiovasculares: {{emoInfo.lifestyles_desc}}
        <br>
        Biomecanico: {{emoInfo.osteomuscular_desc}}
        <br>
        Psicosocial: {{emoInfo.psychosocial_desc}}
        <br>
        Biologico: {{emoInfo.biological_desc}}
        <br>
        Visual: {{emoInfo.visual_desc}}
        <br>
        Auditivo: {{emoInfo.auditivo_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.recommendation_date_desc" label="Fecha Recomendaciones">
        {{emoInfo.recommendation_date_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.recommendations" label="Recomendaciones y/o Restriciones" :span="3">
        {{emoInfo.recommendations}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.imc_desc" label="IMC">
        {{emoInfo.imc_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.commitment_desc" label="Compromiso">
        {{emoInfo.commitment_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.initial_date_desc" label="Fecha Inicio">
        {{emoInfo.initial_date_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.end_date_desc" label="Fecha Fin">
        {{emoInfo.end_date_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.responsable_desc" label="Responsable">
        {{emoInfo.responsable_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.observations" label="Observaciones" :span="3">
        {{emoInfo.observations}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.remission_date_desc" label="Fecha Remisión EPS">
        {{emoInfo.remission_date_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.omedical_exam_date" label="Fecha Examen Medico Ocupacional">
        {{emoInfo.omedical_exam_date}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.con_altura_desc" label="Concepto de Altura">
        {{emoInfo.con_altura_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.con_aptitud_desc" label="Concepto de Aptitud">
        {{emoInfo.con_aptitud_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.con_sig_desc" label="Concepto Favorable por SIG">
        {{emoInfo.con_sig_desc}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.sig_comment" label="Razón por la cual esta Pendiente el Concepto por Parte de SIG:">
        {{emoInfo.sig_comment}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.general_remarks" label="Observaciones Generales" :span="3">
        {{emoInfo.general_remarks}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.created_by" label="Creado Por">
        {{emoInfo.created_by}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.created_on" label="Creado El">
        {{emoInfo.created_on}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.modified_by" label="Modificado Por">
        {{emoInfo.modified_by}}
      </a-descriptions-item>
      <a-descriptions-item v-if="emoInfo.modified_on" label="Modificado El">
        {{emoInfo.modified_on}}
      </a-descriptions-item>
    </a-descriptions>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
  export default {
    props: ['emoInfo'],
    data () {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/EMODetails.vue